import { useEffect } from "react";

const SITE_NAME = "MathMinds";

function upsertMeta(name, content) {
    let element = document.head.querySelector(`meta[name="${name}"]`);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
}

export default function usePageMetadata({ title, description }) {
    useEffect(() => {
        document.title = `${title} | ${SITE_NAME}`;
        upsertMeta("description", description);
    }, [description, title]);
}
